import { mapActions, mapGetters, mapMutations } from "vuex";

import enterForm from "@/components/enter-forms/index.vue";
import registerForm from "@/components/register-forms/index.vue";
import FacebookWidget from "@/components/widgets/facebook/index.vue";
import GoogleWidget from "@/components/widgets/google/index.vue";
import EnterPhone from "@/components/enter-forms/enter-phone-form/index.vue";

export default {
    name: "register-popup",
    data() {
        return {
            activeTab: "enter",
        };
    },
    components: {
        enterForm,
        registerForm,
        FacebookWidget,
        GoogleWidget,
        EnterPhone,
    },
    watch: {},
    computed: {
        ...mapGetters({
            popupRegister: "auth/popupRegister",
        }),
    },
    methods: {
        ...mapActions({
            registration: `auth/REGISTRATION`,
        }),
        ...mapMutations({
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
    },
    destroyed() {},
};
